/* unplugin-vue-components disabled */import script from "./swipers.vue?vue&type=script&setup=true&lang=js"
export * from "./swipers.vue?vue&type=script&setup=true&lang=js"

import "./swipers.vue?vue&type=style&index=0&id=674ed1d3&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674ed1d3"]])

export default __exports__